import React, {useContext} from "react" ;
// import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import AdminModuleContext from "../AdminModuleContext";

const AdminAppBodyHeader= (props) =>
{
    const admin = useContext ( AdminModuleContext ) ;

    const buildHeader = (header, sub_header) =>{
        const pageHeader = <h4 className="title">{header} {sub_header}</h4>;
        return pageHeader;
    }

    const displayHeader = () =>
    {
        return buildHeader(admin.header);
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default AdminAppBodyHeader;
